/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'burger': {
    width: 28,
    height: 18,
    viewBox: '0 0 28 18',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="square"><g transform="translate(-333 -21)" _stroke="#FFF"><g class="svg-burger" transform="translate(334 21)"><path pid="0" d="M.394 1.174h25.212" class="svg-burger__bun"/><path pid="1" d="M.394 9h25.212" class="svg-burger__meat"/><path pid="2" d="M.394 16.826h25.212" class="svg-burger__bun"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/burger.js